import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=156ae712&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=156ae712&prod&scoped=true&lang=css"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=156ae712&prod&scoped=true&lang=css"
import style2 from "./Pagination.vue?vue&type=style&index=2&id=156ae712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ae712",
  null
  
)

export default component.exports